import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { IResult } from "app/common/interfaces";
import { RoutingItineraryAttributes } from "@albatrosdeveloper/ave-models-package";
import { environment as env } from "../../../../../environments/environment.prod";
import { AbstractService } from "app/services/abstract.service";
import { ICreateRoutingItinerary } from "./interfaces/create-routing-itinerary.interface";
import { IUpdateRoutingItinerary } from "./interfaces/update-routing-itinerary.interface";

const apiUrl = env.API_ROUTING_URL;
const moduleName = "routing_itinerary";

@Injectable({
  providedIn: "root",
})
export class RoutingItineraryService extends AbstractService<
  RoutingItineraryAttributes,
  ICreateRoutingItinerary,
  IUpdateRoutingItinerary
> {
  constructor(http: HttpClient) {
    super(apiUrl, moduleName, http);
  }

  findBySubRouteIdAndType(
    subRouteId: string,
    type: string
  ): Observable<IResult<RoutingItineraryAttributes>> {
    const API_URL: string = `${apiUrl}api/${moduleName}/${type}/${subRouteId}`;
    return this.http.get<IResult<RoutingItineraryAttributes>>(API_URL);
  }
}
